module.exports = __webpack_public_path__ + "img/bookmark-add.1c6e70f4.svg";